// Use relative API base in development so devServer proxy forwards requests to the real API.
// In production use the real API URL.
export const API_BASE_URL = process.env.NODE_ENV === 'production'
	? 'https://api.mega-hissotto.com/api'
	: '/api';

